import { useEffect, useCallback } from 'react';

import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { ReactComponent as IconRemove } from 'asserts/icons/ic_x_white.svg';
import { font } from 'asserts/styles/fonts';

interface ViewerProps {
  onClose: () => void;
  selectedTitle?: string;
  selectedItem: string;
}

const IframeViewer = ({ onClose, selectedTitle, selectedItem }: ViewerProps) => {
  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress, { passive: true });

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <Wrapper>
      <CloseAWrapper onClick={onClose}>
        <IconRemove />
      </CloseAWrapper>
      <InnerWrapper>
        {selectedItem?.endsWith('.pdf') ? (
          <iframe
            title={'뷰어'}
            src={selectedItem}
            width="100%"
            height="800px"
            style={{ border: 'none' }}
          />
        ) : (
          <img
            src={selectedItem}
            width="100%"
            height="800px"
            className="image"
            alt={selectedTitle}
          />
        )}
      </InnerWrapper>
    </Wrapper>
  );
};

export default IframeViewer;

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 200;
  padding: 0 24px;
  width: 80%;
  height: 80%;

  & iframe {
    height: 100%;
  }
`;

const CloseAWrapper = styled.p`
  position: absolute;
  top: 64px;
  right: 54px;
  width: 32px;
  height: 32px;
  margin-left: auto;
  z-index: 300;
  cursor: pointer;
`;

const InnerWrapper = styled.div`
  position: relative;
  height: 100%;
  color: ${color.white};
  ${font.h3_medium}

  h3 {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    display: inline-flex;
    padding: 8px 16px;
    align-items: center;
    border-radius: 24px;
    background: ${color.opacityBlack07};
    color: ${color.white2};
    ${font.body_medium}
    z-index: 300;
  }
`;
